import { scaleOrdinal } from 'd3-scale';

export default (conf) => {
  const scale = scaleOrdinal();
  const keys = conf.values.map((v) => v.key);
  const values = conf.values.map((v) => v.value);
  scale.range(values).domain(keys);

  if (conf.unknown) scale.unknown(conf.unknown);

  return {
    id: conf.id,
    field: conf.field,
    options: conf,
    transformer: (domain, range) => {
      const transformer = scale.copy();
      if (domain !== undefined) transformer.domain(domain);
      if (range !== undefined) transformer.range(range);
      return transformer;
    },
  };
};
